import { get, httpDelete, patch, post } from 'api/client';
import config from 'config';
import { PostLabel } from 'types/Post';

const TagsApi = {
  getRecent(pageId: number, limit?: number): Promise<PostLabel[]> {
    return get(`page/${pageId}/recent-tags`, {
      baseURL: config.API_SERVICE_ENDPOINT,
      params: {
        limit,
      },
    });
  },
  async getAll(pageId: number): Promise<PostLabel[]> {
    return await get<PostLabel[]>(`/pages/${pageId}/tags`, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },
  async create(data: {
    pageId: number;
    name: string;
    color?: string;
  }): Promise<PostLabel> {
    return await post<PostLabel>(
      `/pages/${data.pageId}/tags`,
      {
        name: data.name,
        ...(data.color ? { color: data.color } : {}),
      },
      {
        baseURL: config.API_SERVICE_ENDPOINT,
      },
    );
  },
  async update(
    id: number,
    data: { name: string; color?: string | null },
  ): Promise<PostLabel> {
    return await patch<PostLabel>(
      `/tags/${id}`,
      {
        name: data.name,
        color: data.color,
      },
      {
        baseURL: config.API_SERVICE_ENDPOINT,
      },
    );
  },
  getAllLegacy(pageId: number): Promise<PostLabel[]> {
    return get('tags/ajaxGetTags', {
      params: {
        pageId,
      },
    });
  },
  createLegacy(data: {
    pageId: number;
    name: string;
    color?: string;
  }): Promise<PostLabel> {
    const formData = new FormData();

    formData.append('page_id', data.pageId.toString());
    formData.append('name', data.name);

    if (data.color) {
      formData.append('color', data.color);
    }

    return post('tags/ajaxCreateNewTag', formData);
  },
  delete(id: number): Promise<void> {
    return httpDelete(`/tags/${id}`, {
      baseURL: config.API_SERVICE_ENDPOINT,
    });
  },
};

export default TagsApi;
